import React, { useEffect, useState } from "react";
import useSelectedFinYear from "../../../utils/selectedFinyear";
import CustomDate1 from "../../../Pages/corpaction/corpActionMaster/date/CustomDate1";
import CustomDate from "../../../Pages/corpaction/corpActionMaster/date/CustomDate";
import { format, subDays } from "date-fns";

const IndustryScripHeader = ({ setFilter }) => {
  const [handleSetValue, setHandleSetValue] = useState();
  const { currentDateStr } = useSelectedFinYear();
  const handleFilter = (val) => {
    if (val === "empty") {
      setHandleSetValue();
      setFilter();
    } else {
      setFilter(handleSetValue);
    }
  };

  useEffect(() => {
    if (!currentDateStr) return;
    const cur = new Date(currentDateStr);
    const exDate = subDays(cur, 1);
    const recordDt = subDays(exDate, 7);

    setHandleSetValue({
      nse_exdate: format(exDate, "yyyy-MM-dd"),
      bookclose_recorddate: format(recordDt, "yyyy-MM-dd"),
    });
    setFilter({
      nse_exdate: format(exDate, "yyyy-MM-dd"),
      bookclose_recorddate: format(recordDt, "yyyy-MM-dd"),
    });
  }, [currentDateStr]);

  return (
    <div className=" flex w-full items-baseline gap-2 pt-[10px]">
      <div className="mb-8 flex w-full flex-wrap items-baseline gap-4">
        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-[200px]  flex-col gap-3 ">
            <label>Start Date</label>
            <CustomDate
              className={"bg-[#F7F7F7]"}
              initialValue={handleSetValue?.bookclose_recorddate}
              setHandleSetValue={setHandleSetValue}
              // Auto email reading started from 2025-04-04
              min={"2025-04-04"}
              max={
                handleSetValue?.nse_exdate
                  ? handleSetValue?.nse_exdate
                  : currentDateStr
              }
            />
          </div>
        </div>
        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-[200px]  flex-col gap-3 ">
            <label>End Date</label>
            <CustomDate1
              className={"bg-[#F7F7F7]"}
              initialValue={handleSetValue?.nse_exdate}
              setHandleSetValue={setHandleSetValue}
              handleValue={handleSetValue}
              min={
                handleSetValue?.bookclose_recorddate
                  ? handleSetValue?.bookclose_recorddate
                  : "2025-04-04"
              }
              max={currentDateStr}
            />
          </div>
        </div>
      </div>
      <div className="flex justify-end space-x-4">
        <div className=" flex  items-stretch gap-4 text-neutral-600">
          <div className="flex   flex-col gap-3 ">
            <label className="text-[#fff0]">.</label>
            <button
              onClick={() => handleFilter()}
              className="w-full max-w-[100px] gap-2 rounded-md bg-[#F2673A] px-6 py-[8px] text-center font-semibold text-white hover:brightness-95"
            >
              SUBMIT
            </button>
          </div>
        </div>

        <div className=" flex items-stretch gap-4 text-neutral-600">
          <div className="flex  flex-col gap-3 ">
            <label className="text-[#fff0]">.</label>
            <button
              onClick={() => handleFilter("empty")}
              className="w-full max-w-[100px]  gap-2 rounded-md bg-[#F2673A] px-6 py-[8px] text-center font-semibold text-white hover:brightness-95"
            >
              CLEAR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustryScripHeader;
